var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQNewLine = function SvgQNewLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3173DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.875,
    clipPath: "url(#q_new_line_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.44 8.17H1.54V1.584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.553 12.42 4.912-4.248-4.912-4.25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "q_new_line_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.544h15v12.912H.5z"
  })))));
};
export { SvgQNewLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIiBjbGlwLXBhdGg9InVybCgjY2xpcDBfNzU1M18zOTYyNykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTMuNDM5NCA4LjE3MDc0SDEuNTM5MDZWMS41ODMwMSIgc3Ryb2tlPSIjMzE3M0RCIiBzdHJva2Utd2lkdGg9IjEuODc1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik05LjU1MjczIDEyLjQyMDVMMTQuNDY1MSA4LjE3MTY2TDkuNTUyNzMgMy45MjI4NSIgc3Ryb2tlPSIjMzE3M0RCIiBzdHJva2Utd2lkdGg9IjEuODc1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzc1NTNfMzk2MjciPgo8cmVjdCB3aWR0aD0iMTUiIGhlaWdodD0iMTIuOTEyNSIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAwLjU0Mzk0NSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";